<div class="modal-view-expand w-full h-[85vh] flex flex-col relative">
  <div class="w-full z-10 flex justify-between p-3 widget-bg-color" *ngIf="viewHeader">
    <h1 class="text-[2rem] font-bold truncate">{{ data.name }}</h1>
    <div class="flex">
      <button
        *ngIf="((data?.expiryDate | dateNotExpired) || (AccessAsset(data) | can : 'expired.download')) && ((data && (AccessAsset(data) | can : 'download')) || externalUserFlag)"
        class="w-auto button-primary !mr-4 flex items-center whitespace-nowrap"
        [disabled]="!(data && (data ? (AccessAsset(data) | can : 'download') : true)) && !externalUserFlag"
        (click)="this.assetCommonService.downloadAsset(data, moduleName)"
      >
        <mat-icon class="material-icons-outlined mr-3">file_download</mat-icon>
        <span i18n>Download asset</span>
      </button>
      <i class="cursor-pointer bg-white h-7 w-auto border-2" (click)="closeFullScreen()">
        <mat-icon>close</mat-icon>
      </i>
    </div>
  </div>
  <div *ngIf="!viewHeader">
    <i class="z-10 cursor-pointer absolute bg-white h-7 w-7 top-3 right-3 border-2 border-color" (click)="closeFullScreen()">
      <mat-icon>close</mat-icon>
    </i>
  </div>
  <div *ngIf="data.previewUrl" class="z-0 w-full relative flex items-center" style="height: calc(100% - 80px); margin: auto; width: calc(100% - 80px)">
    <div *ngIf="data.previewUrl && data.assetType === AssetTypes.Image" class="w-full h-full">
      <thehubz-asset-image [asset]="data" class="w-full h-full"></thehubz-asset-image>
    </div>
    <div *ngIf="data.assetType === AssetTypes.PowerpointPresentation" class="w-full h-full rounded-full">
      <thehubz-asset-power-point [asset]="data" class="w-full h-full"></thehubz-asset-power-point>
    </div>
    <div *ngIf="data.previewUrl && data.assetType === AssetTypes.HtmlBanner" class="w-full h-full rounded-full p-[2px] pt-11">
      <thehubz-asset-html-banner [asset]="data" class="w-full h-full" [toolbar]="true"></thehubz-asset-html-banner>
    </div>
    <div *ngIf="data.assetType === AssetTypes.Pdf" class="w-full h-full rounded-full pt-12 pr-3">
      <thehubz-asset-pdf [asset]="data" class="w-full h-full" [hideFullScreen]="true"></thehubz-asset-pdf>
    </div>
    <div *ngIf="data.previewUrl && data.assetType === AssetTypes.Video" class="w-full h-full">
      <thehubz-asset-video [asset]="data" class="w-full h-full"></thehubz-asset-video>
    </div>
  </div>
  <div *ngIf="!data.previewUrl && (data?.expiryDate | dateNotExpired)" class="h-full w-full flex justify-center items-center">
    <span class="text-xl font-bold" i18n>Preview Not Available</span>
  </div>

  <!-- Overlay for expired assets -->
  <sp-overlay class="asset-overlay-semitransparent" *ngIf="data && !(data.expiryDate | dateNotExpired)">
    <span class="text-7xl font-bold" i18n>Expired</span>
  </sp-overlay>
</div>
